(function($) {

	'use strict';

   
	var init = function() {
        
        showMoreDoc();
        iframeResize();
        focus();

    }

    var focus = function(){
        var mouseDown = false;
        var element = $('*:not(input:not([type="submit"])):not(textarea):not(label[for])');

		element.on('mousedown', function(){
			mouseDown = true;
		});

		element.on('mouseup', function(){
			mouseDown = false;
		});

		element.on('focus', function(event){
			if (mouseDown) {
				event.target.blur();
			}
		});
    }

    
    var showMoreDoc = function(){

        $('#show_more_doc').click(function(){
            
            $('#download').toggleClass('active');
            
        });

    };
    
    var iframeResize = function(){
        
        $(window).resize(function(){
                        
            var videoWidth = $('.blocMedia iframe').outerWidth();
            
            $('.blocMedia iframe').height( (videoWidth / 16) * 9 );
            
        }).resize();
        
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);
